import axios from "axios";
import * as url from "./url_helper";
let tokenPrefix = "Bearer ";
if (custom_loader_count === undefined) var custom_loader_count = 0;
export const respStatus = {
  SUCCESS: "SUCCESS",
  ERROR: "ERROR",
  NOT_AUTHORISED: "You are not authorised.",
};
// Register Method
const base_url = window.location.origin;
const axiosApi = axios.create({
  baseURL:
    process.env.REACT_APP_ENABLE_LOCAL_API == 1
      ? process.env.REACT_APP_API_URL
      : base_url,
});

axiosApi.interceptors.request.use((config) => {
  let common_request_data = {
    [url.LOBBY_KEY]: process.env.REACT_APP_LOBBY,
    [url.LOBBY_MOB_PERM]: 'new_cd_lob_mob_status',
    [url.LOBBY_WEB_PERM]: 'new_cd_lob_web_status',
    [url.LOBBY_VERSION_KEY]: process.env.REACT_APP_LOBBY_VERSION
  };
  console.log('axiosApi.interceptors.request', common_request_data);
  if (config.method === 'get') {
    config.params = {
      ...config.params,
      common_request_data: common_request_data,
    };
  } else {
    if (config.data instanceof Array) {
      config.data = {
        data: config.data,
        common_request_data: common_request_data,
      };
    } else if (config.data == null) {
      config.data = {
        common_request_data: common_request_data,
      };
    } else {
      config.data = {
        ...config.data,
        common_request_data: common_request_data,
      };
    }
  }

  return config;
}, (error) => {
  console.error('axiosApi.interceptors.request', error);
  return Promise.reject(error);
});

axiosApi.interceptors.response.use(
  (response) => response,
  (error) => Promise.reject(error)
);

const userAgent = navigator.userAgent.toLowerCase();
const isMobile = /android|iphone|ipad|ipod/i.test(userAgent);
const isWebView = userAgent.includes('wv');

const handelLogout = () => {
  if (isMobile) {
    if (isWebView) {
      window.location.href = document.referrer;
    } else {
      window.close();
    }
  } else {
    window.close();
  }
};

const makeAjax = (
  extension,
  data,
  micro_service = url.CARD_GANE_MS_EXT,
  header = {}
) => {

  if (extension === url.PLAYER_API.addUserSession) {
    localStorage.removeItem(url.TOKEN_KEY);
    localStorage.setItem("promoBanners", []);
  }
  startLoader(extension);
  let token = tokenPrefix + localStorage.getItem(url.TOKEN_KEY);

  let APPLICATION_EXT = url.APPLICATION_EXT;

  if (micro_service == url.ARCADE_MS_EXT) {
    APPLICATION_EXT = "/partner-api";
    axiosApi.defaults.baseURL = process.env.REACT_APP_ARCADE_API_URL
  }

  axiosApi.defaults.headers.common["Authorization"] = token;

  let end_url =
    url.API_PREFIX + micro_service + APPLICATION_EXT + extension;
  if (process.env.REACT_APP_ENABLE_LOCAL_API == 2) {
    end_url = micro_service + APPLICATION_EXT + extension;
  }
  // console.log("lobby access ====>", process.env);
  if (!header['headers'])
    header['headers'] = {}
  header['headers'][url.LOBBY_KEY] = process.env.REACT_APP_LOBBY;
  header['headers'][url.LOBBY_MOB_PERM] = 'new_cd_lob_mob_status';
  header['headers'][url.LOBBY_WEB_PERM] = 'new_cd_lob_web_status';
  header['headers'][url.LOBBY_VERSION_KEY] = process.env.REACT_APP_LOBBY_VERSION;
  return axiosApi
    .post(end_url, data, header)
    .then((response) => {
      if (response.status >= 200 || response.status <= 299) {
        if (response.data.status == "ERROR") {
          if ((response.data.code == "invalid_token_error" || response.data.code == "contact_to_customer_err") && extension != url.PLAYER_API.verifyLogin) {
            localStorage.removeItem(url.TOKEN_KEY);
            localStorage.setItem("promoBanners", []);
            if (isWebView) {
              handelLogout();
            }
            else {
              window.location.href = base_url + "/sessionexpired";
            }
          }
          else if (response.data.code == "inactive_partner" && response.data.code == "contact_to_customer_err") {
            showMessage(response);
            localStorage.removeItem(url.TOKEN_KEY);
            localStorage.setItem("promoBanners", []);
            window.location.href = base_url + "/maintenance";
          }
          else if (response.data.code === "page_refresh") {
            window.location.reload()
          }
        }
        stopLoader(extension);
        return response.data;
      }
      stopLoader(extension);
      return { status: "ERROR", data: null };
    })
    .catch((err) => {
      stopLoader(extension);
      catchAxioExc(err);
      return { status: "ERROR", data: null, messages: generateCatchMsg(err) };
    });
};

const startLoader = (extension) => {
  if (!url.EXCLUDE_LOADER.includes(extension)) {
    let element = document.getElementById("ajax-loader");
    if (element) {
      if (custom_loader_count == 0) {
        element.classList.remove("hideMe");
      }
      custom_loader_count++;
    }
  }
};

const stopLoader = (extension) => {
  if (!url.EXCLUDE_LOADER.includes(extension)) {
    let element = document.getElementById("ajax-loader");
    if (element) {
      if (custom_loader_count != 0) custom_loader_count--;
      if (custom_loader_count == 0) {
        element.classList.add("hideMe");
      }
    }
  }
};


const generateCatchMsg = (err) => {
  var message;
  if (err.response && err.response.status) {
    switch (err.response.status) {
      case 404:
        message = "Sorry! the API you are looking for could not be found";
        break;
      case 500:
        message =
          "Sorry! something went wrong, please contact our support team";
        break;
      case 401:
        message = "Invalid credentials";
        break;
      default:
        message = err[1];
        break;
    }
    return message;
  }
};
const catchAxioExc = (err) => {
  var message = generateCatchMsg(err);
  showMessage(message, "error");
};
const showMessage = (data, toastType, title) => {
  if (data?.code === "invalid_token_error") {
    setTimeout(() => {
      handelLogout();
    }, 2000);
    return;
  }
  let message = data;
  if (data.messages) message = data.messages;
  if (!toastType) {
    toastType = data.status == "SUCCESS" ? "SUCCESS" : "error";
  }
  if (!title) title = toastType == "success" ? "Success" : camelCase(toastType);
  toastMessage(message, toastType, title);
  if (data.code === "you_ve_been_logged_out_successfully") {
    setTimeout(() => {
      handelLogout();
    }, 2000);
  }
};
const toastMessage = (message, type, heading = "Error") => {
  const wrapperElement = document.querySelector(".wrapper");
  const toasterElement = document.getElementById("commonToaster");

  wrapperElement.classList.add("popup-open");
  toasterElement.style.display = "flex";
  document.getElementById("commonToasterHeading").innerHTML = heading;
  document.getElementById("commonToasterBody").innerHTML = message;

  // Handle close when user clicks the close button
  const closeBtn = toasterElement.querySelector(".close");
  closeBtn.onclick = () => {
    toasterElement.style.display = "none";
    wrapperElement.classList.remove("popup-open"); // Remove popup-open class
  };
};

const camelCase = (message) => {
  return message.charAt(0).toUpperCase() + message.slice(1);
};
const formatDate = (date) => {
  let arr = date.split(/[- :]/);
  let d = new Date(arr[0], arr[1], arr[2], arr[3], arr[4], arr[5]);
  return appendZero(d.getDate()) + '-' + appendZero(d.getMonth()) + '-' + appendZero(d.getFullYear()) + ' ' + appendZero(d.getHours()) + ':' + appendZero(d.getMinutes());
};
const appendZero = (val) => {
  return (val < 10) ? '0' + val : val;
}

// Convert string to ArrayBuffer
const strToArrayBuffer = (str) => new TextEncoder().encode(str);

// Convert ArrayBuffer to Base64
const arrayBufferToBase64 = (buffer) => {
  return btoa(String.fromCharCode(...new Uint8Array(buffer)));
};

// Convert Base64 to Uint8Array
const base64ToUint8Array = (base64) => {
  const binary = atob(base64);
  const bytes = new Uint8Array(binary.length);
  for (let i = 0; i < binary.length; i++) {
    bytes[i] = binary.charCodeAt(i);
  }
  return bytes;
};

// Derive AES-256-CBC key by hashing the secret with SHA-256
const getAesKey = async (secret) => {
  const keyMaterial = strToArrayBuffer(secret);
  const hashedKey = await crypto.subtle.digest("SHA-256", keyMaterial);
  return crypto.subtle.importKey("raw", hashedKey, "AES-CBC", false, ["encrypt", "decrypt"]);
};

// Encrypt a string or number
const encryptData = async (plaintext) => {
  const secretKey = localStorage.getItem('partner_username') || '';
  const key = await getAesKey(secretKey);
  const iv = crypto.getRandomValues(new Uint8Array(16));
  const textToEncrypt = typeof plaintext === 'number' ? plaintext.toString() : plaintext;
  const encrypted = await crypto.subtle.encrypt(
    { name: "AES-CBC", iv },
    key,
    strToArrayBuffer(textToEncrypt)
  );

  // Combine IV + ciphertext
  const combined = new Uint8Array(iv.length + encrypted.byteLength);
  combined.set(iv, 0);
  combined.set(new Uint8Array(encrypted), iv.length);

  return arrayBufferToBase64(combined.buffer);
};


const decryptData = async (base64Data) => {
  const secretKey = localStorage.getItem('partner_username') || '';
  const key = await getAesKey(secretKey);

  try {
    const combinedBytes = base64ToUint8Array(base64Data);
    const iv = combinedBytes.slice(0, 16); // Ensure 16 bytes
    const ciphertext = combinedBytes.slice(16);

    // Optional sanity checks
    if (iv.length !== 16) throw new Error("IV length is not 16 bytes");
    if (!(iv instanceof Uint8Array)) throw new Error("IV is not Uint8Array");

    const decrypted = await crypto.subtle.decrypt(
      { name: "AES-CBC", iv },
      key,
      ciphertext
    );

    return new TextDecoder().decode(decrypted);

  } catch (err) {
    console.error("❌ Decryption failed:", err.message);
    return null;
  }
};

const formatDateNew = (date) => {
  let arr = date.split(/[- :]/);

  let d = new Date(arr[0], arr[1] - 1, arr[2], arr[3], arr[4], arr[5]);

  return (
    appendZero(d.getDate()) +
    '-' +
    appendZero(d.getMonth() + 1) +
    '-' +
    d.getFullYear() +
    ' ' +
    appendZero(d.getHours()) +
    ':' +
    appendZero(d.getMinutes())
  );
};

const handleLogout = (TOKEN_KEY) => {
  makeAjax(url.PLAYER_API.logout, {}, url.PLAYER_MS_EXT).then((response) => {
    if (response.status === respStatus["SUCCESS"]) {
      showMessage(response);
      localStorage.removeItem(TOKEN_KEY);
      localStorage.removeItem("partner_token");
      localStorage.removeItem("promoBanners");
      localStorage.removeItem("current_user_session");
      localStorage.setItem("__ps", null);
    }
  });
};

export { makeAjax, url, tokenPrefix, showMessage, camelCase, formatDate, encryptData, decryptData, isWebView, formatDateNew, handleLogout };
